import type React from 'react';
import type { IconProps } from 'types/icon';

const Pills: React.FC<IconProps> = ({
  size = '24',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...attributes}
    >
      <path
        d="M10.8753 3.62303C12.5079 1.99035 15.1565 1.99035 16.7891 3.62303C18.4217 5.25567 18.4216 7.9038 16.7891 9.53647L9.53638 16.7892C7.90372 18.4217 5.25559 18.4217 3.62295 16.7892C1.99027 15.1565 1.99027 12.508 3.62295 10.8753L10.8753 3.62303ZM16.0569 4.35523C14.8286 3.1269 12.8358 3.1269 11.6075 4.35523L4.35514 11.6075C3.12682 12.8359 3.12682 14.8287 4.35514 16.057C5.58348 17.2853 7.57634 17.2853 8.80463 16.057L16.0569 8.80472C17.2852 7.57642 17.2852 5.58357 16.0569 4.35523Z"
        fill={color}
      />
      <path
        d="M7.40859 7.13716C7.67135 7.02451 7.97576 7.14626 8.08845 7.40902C9.03518 9.61658 10.7907 11.3721 12.9983 12.3188C13.261 12.4315 13.3828 12.7359 13.2701 12.9987C13.1575 13.2614 12.853 13.3832 12.5903 13.2706C10.1385 12.2191 8.18817 10.2688 7.13673 7.81703C7.02408 7.55426 7.14583 7.24985 7.40859 7.13716Z"
        fill={color}
      />
      <path
        d="M20.5642 16.9408C20.5642 14.9394 18.9419 13.3167 16.9405 13.3167C14.9391 13.3167 13.3163 14.9394 13.3163 16.9408C13.3164 18.9423 14.9391 20.5645 16.9405 20.5645C18.9419 20.5645 20.5642 18.9422 20.5642 16.9408ZM21.5998 16.9408C21.5997 19.5141 19.5138 21.6001 16.9405 21.6001C14.3672 21.6001 12.2813 19.5141 12.2812 16.9408C12.2812 14.3675 14.3672 12.2816 16.9405 12.2816C19.5138 12.2816 21.5998 14.3675 21.5998 16.9408Z"
        fill={color}
      />
      <path
        d="M19.1629 13.9819C19.3651 13.7797 19.693 13.7797 19.8951 13.9819C20.0973 14.184 20.0973 14.5115 19.8951 14.7136L14.7135 19.8953C14.5113 20.0974 14.1839 20.0974 13.9817 19.8953C13.7795 19.6931 13.7795 19.3653 13.9817 19.1631L19.1629 13.9819Z"
        fill={color}
      />
    </svg>
  );
};

export default Pills;
